<template>
  <div>
    <h2>{{ $t("errors") | capitalize }}</h2>
    <!-- Global Errors -->
    <template v-if="item && item.status_string && onlyShowFileLevelErrors">
      <div :key="index" v-for="(line, index) in item.status_string.split('\n')">
        <p class="mb-1">{{ cleanupLine(line) }}</p>
      </div>
    </template>

    <!-- Row Errors -->
    <v-server-table
      v-if="item && !onlyShowFileLevelErrors"
      v-show="errorCount"
      ref="fileErrorsTable"
      :url="url"
      :columns="columns"
      :options="options"
    />
  </div>
</template>

<script>
import { capitalize, trim } from "lodash"
import { doRequest } from "@/assets/libs/utils"

export default {
  name: "FileErrorsTable",
  computed: {
    url () { return `/${this.module}/${this.item?.id}/errors` }
  },
  data () {
    return {
      columns: ["item_seq", "field", "type", "reason"],
      errorCount: 0,
      options: {
        skin: "table table-striped modal-table",
        headings: {
          item_seq: capitalize(this.$t("item")),
          field: capitalize(this.$t("field")),
          type: capitalize(this.$t("type")),
          reason: capitalize(this.$t("reason")),
        },
        sortable: [],
        perPage: 15,
        responseAdapter ({ data }) {
          this.$parent.$parent.errorCount = data.count
          this.error_count = data.count
          return {
            data: data.results,
            count: data.count,
          }
        },
        requestFunction (params) {
          return doRequest(this.url, params)
        }
      }
    }
  },
  methods: {
    cleanupLine (line) {
      return trim(line, "()''")
    }
  },
  props: {
    item: Object,
    module: String,
    onlyShowFileLevelErrors: {
      type: Boolean,
      default: false,
    },
  }

}
</script>
